import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PurchaseSubscriptionBlocker.module.scss';
import { ReactComponent as CheckIcon } from '../../../assets/images/icons/check.svg';

export default function PurchaseSubscriptionBlocker() {
  const { t } = useTranslation();
  return (
    <div className={styles.main}>
      <div className={styles.avatar}></div>

      <div className={styles.content}>
        <h2>{t('join_the_pack')}</h2>
        <p>{t('before_activating_your_fi_device_select_a_payment_plan')}</p>
        <h3>{t('included_with_each_plan')}</h3>
        <ul>
          <li>
            <CheckIcon className={styles.check} />
            {t('gps_lte_location_tracking')}
          </li>
          <li>
            <CheckIcon className={styles.check} />
            {t('escape_detection_dog_walker_tracking')}
          </li>
          <li>
            <CheckIcon className={styles.check} />
            {t('steps_sleep_and_strain_monitoring')}
          </li>
          <li>
            <CheckIcon className={styles.check} />
            {t('health_benchmarks_and_goals')}
          </li>
          <li>
            <CheckIcon className={styles.check} />
            {t('fi_community_access')}
          </li>
        </ul>
      </div>
    </div>
  );
}
